import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from "@angular/router";

@Component({
  selector: 'app-mmt-message',
  templateUrl: './mmt-message.component.html',
  styleUrls: ['./mmt-message.component.css']
})
export class MmtMessageComponent implements OnInit {
  
  constructor( private router: Router, private dialogRef: MatDialogRef<MmtMessageComponent>) { 
    
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  setClientIncome(){
    this.close();
    //this.router.navigate(['/reports/hc-questionnaire'], { state: { params: 'income' } });

    this.router.navigate(['/clients/edit/healthcare'], { state: { params: 'income' } });
  }

}
